import React, { useEffect, useState } from "react";
import { Chart, Series, CommonSeriesSettings } from "devextreme-react/chart";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";
import { Card } from "react-bootstrap";

const override = {
  display: "block",
  margin: "0 auto",
};

const Revenue = () => {
  let revenuear = [];
  const [revenue, setRevenue] = useState([]);
  const [loading, setLoading] = useState(false);
  const { apiKey } = useParams();

  const getRevenue = async () => {
    const res = await fetch("api/Revenue/getRentalPaymentsTenant/" + apiKey);
    if (res.ok) {
      const data = await res.json();
      setRevenue(data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  useEffect(() => {
    getRevenue();

    const autoR = setInterval(() => {
      getRevenue();
    }, 15 * 60 * 1000);

    return () => clearInterval(autoR);
  }, []);

  function changeFormatting() {
    revenuear = [
      { value: revenue.paidSum, arguments: "Betaald" },
      { value: revenue.unpaidSum, arguments: "Onbetaald" },
    ];
  }
  changeFormatting();


  return (
    <>
      <Card>
        <Card.Header className="fw-bold text-center fs-5">Omzet</Card.Header>
        <Card.Body>
          {loading ? (
            <div>
              <ClipLoader
                color="#5b36d6"
                loading={loading}
                cssOverride={override}
                speedMultiplier="0.8"
                size={35}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : (
            <Chart dataSource={revenuear}>
              <CommonSeriesSettings
                argumentField="arguments"
                type="bar"
                barPadding={0.8}
              />
              <Series valueField="value" showInLegend={false} color="blue"/>
            </Chart>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default Revenue;
